import { render, staticRenderFns } from "./CreateTenantSubscriptionModal.vue?vue&type=template&id=5df6f966&scoped=true&"
import script from "./CreateTenantSubscriptionModal.vue?vue&type=script&lang=js&"
export * from "./CreateTenantSubscriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6f966",
  null
  
)

export default component.exports